import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Articles from './Articles';
import Loading from './loading';

const About = ({ loading, loadingPosts, posts, currentUser, dispatchPosts, setBanner, banner, socket }) => {

    const [reload, setReload] = useState(true);

    useEffect(() => {
        if (reload) {
            setBanner({ ...banner, loading: false, id: 0 });
            setReload(false);
            window.scrollTo(0, 0);
        }
    }, [setBanner, setReload, banner, reload]);

    return (
        <Box>
            {(!loadingPosts) ? (
                <Articles
                    isLoading={loading}
                    data={posts}
                    dispatchPosts={dispatchPosts}
                    currentUser={currentUser}
                    type='about'
                    socket={socket}
                />
            ) : (
                <Loading />
            )}
        </Box>
    )
};

export default About;
